import kendo from '@progress/kendo-ui';

import { AppStorage } from '@/app/shared/services/app-storage/app-storage.js';
//import { backOfficeUrl } from '@/environment/environment';
//import { timeZoneOffset } from '@/environment/environment';    //filter  timezone fix
import router from '@/app/app-routes'
let storage = new AppStorage();
import { EventBus } from '@/app/shared/services/event-bus.js';

//const datasource = {
//    type: "odata",
//    serverFiltering: true,
//    serverPaging: true,

//    pageSize: 4,
//    transport: {
//        read: {
//            url: "https://demos.telerik.com/kendo-ui/service/Northwind.svc/Products",
//            beforeSend: function (xhr) {//Token
//                var token = "";
//                if (storage.getItem('Token') != null)
//                    token = storage.getItem('Token').Value;
//                xhr.setRequestHeader('Authentication', token);
//            }
//        }
//    }

//};
//const kendoService = datasource;

//function GetTimeZoneOffsetString() {
//    
//    var intOffsetInSec = (new Date().getTimezoneOffset());
//    var intOffsetInHour = intOffsetInSec / 60*-1; //-2
//    var strOffset = '';

//    if (intOffsetInHour == 0) {
//        strOffset = '.000Z';
//    }
//    else {
//        strOffset = (intOffsetInHour > 0 ? '+' : '-') +
//            (intOffsetInHour < 10 ? '0' + intOffsetInHour : intOffsetInHour) +
//            ':00';
//    }

//    return strOffset;

//}

export class KendoService {
    constructor(url, pageSize, modelID, fields, sortField, isWithPaging = true, sortType = "desc", isListMode = true, DDlFilterParams, parameterMapExtendedOptions = null, SortCallBack = null,parseResponseMethod=null,group=null) {
        
        if (url.includes('?'))
            url = url + "&$count=true";
        else
            url = url + "?$count=true";

        if (isWithPaging) {
         
                this.data = {
                    type: "odata-v4",
                    serverFiltering: true,
                    serverPaging: true,
                    serverSorting: true,
                    pageSize: pageSize,
                    transport: {
                        read:
                        {
                            url: url,
                            contentType: "application/json; charset=utf-8",
                            dataType: "json",
                            xhrFields: {
                                withCredentials: true
                            },
                            beforeSend: function (xhr) {//Token                        
                                xhr.withCredentials = true;
                                var token = "";

                                if (storage.getItem('Token') != null)
                                    token = storage.getItem('Token').Value;
                                xhr.setRequestHeader('Authentication', token);

                            }
                        },
                        parameterMap:function (options) {
                            if (!isListMode) {
                                for (var z = 0; z < DDlFilterParams.length; z++) {
                                    options.filter.filters.push({
                                        "value": DDlFilterParams[z].value,
                                        "operator": DDlFilterParams[z].operator,
                                        "field": DDlFilterParams[z].field,
                                        "ignoreCase": "true"
                                    });
                                }

                            }

                            if (!options.sort) {
                                if (sortField) {
                                    options.sort = [{ field: sortField, dir: sortType }];
                                }
                            }
                            else if (options.sort.length == 0)
                                options.sort.push({ field: sortField, dir: sortType });

                            if (SortCallBack != null) {
                                SortCallBack(options);
                            }


                            var paramMap = kendo.data.transports.odata.parameterMap(options);
                            delete paramMap.$inlinecount; // <-- remove inlinecount parameter.
                            //To Allow Grid Filtring where it search with "Substring" Keyword and Odata  understand only "contains" Keyword so 
                            //this lines will loop for filters and replace itv with  the correct formate

                            if ( paramMap.$filter) {

                                paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
                                    return x.substring(1, x.length - 1);
                                });
                                var Params = paramMap.$filter.split(" and ");
                                paramMap.$filter = "";
                                for (var i = 0; i < Params.length; i++) {
                                    var field = null;
                                    if (options && options.filter && options.filter.filters[i]) {
                                        if (options.filter.filters[i].logic) {
                                            if (i > 0 && options.filter.filters[i - 1].logic == "and") {
                                                field = options.filter.filters[i - 1].filters[0].field;
                                            } else {
                                                field = options.filter.filters[i].filters[0].field;
                                            }
                                        }
                                        else {
                                            field = options.filter.filters[i].field;
                                        }
                                    }
                                    else if(options && options.filter){
                                        if (options.filter.filters[i - 1].logic) {
                                            field = options.filter.filters[i - 1].filters[0].field;
                                        }
                                        else {
                                            field = options.filter.filters[i - 1].field;
                                        }
                                    }
                                   
                                        var datefilter = Params[i].split("datetime'");
                                        if (field && datefilter.length > 1) {

                                        for (var j = 0; j < datefilter.length; j++) {
                                                if (j == datefilter.length - 1) {

                                                    paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", ".000Z");
                                                    //paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", timeZoneOffset);
                                                    //var timeZoneOffsetStr = GetTimeZoneOffsetString();
                                                    //paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", "+02:00");
                                                }
                                                else {
                                                   
                                                    paramMap.$filter = paramMap.$filter + datefilter[j].replace(field, "cast(" + field + ",'Edm.DateTimeOffset')");
                                                }
                                            }
                                        }
                                        else {
                                            paramMap.$filter = paramMap.$filter + Params[i].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
                                        }
                                    
                                        if (i != Params.length - 1) {
                                            paramMap.$filter = paramMap.$filter + " and ";
                                        }
                                    
                                }
                            }

                            if (parameterMapExtendedOptions) {
                                paramMap = Object.assign({}, paramMap, parameterMapExtendedOptions)
                            }

                            return paramMap;

                        },
                    },
                    error: function (e) {

                        var xhr = e.xhr;

                        //var statusCode = e.status;
                        //var errorThrown = e.errorThrown;
                        if (xhr.status == 422) {
                            if (xhr.getAllResponseHeaders().toLowerCase().indexOf('sessionexpire') > -1) {//expired token and not authorized                            
                                EventBus.$emit('InternalServerError', xhr.statusText);
                                localStorage.clear();
                                router.push('/');
                            }
                            else {
                                router.push('/401');
                            }
                        }
                        else if (xhr.status == 500) {
                            // $state.go("app.error");
                            console.log(xhr.status);

                        }
                        else if (xhr.status == 0) {
                            console.log(xhr.status);

                        }
                        else if (xhr.status == 205) {
                            console.log(xhr.status);

                        }
                        else if (xhr.responseText != null && xhr.responseText.includes("StatusCode: 401")) {
                            //window.location.href = backOfficeUrl + "401";
                            router.push('/401');
                        }

                        else {
                            console.log(xhr.status);
                        }

                    },
                    schema: {

                        data: function (data) {

                            if (Array.isArray(data)) {
                                if (parseResponseMethod != null) {

                                    return parseResponseMethod.format(data);
                                }
                                return data
                            }

                            if (parseResponseMethod != null) {
                                
                                return parseResponseMethod.format(data.value);
                            }

                            return data.value; // <-- The result is just the data, it doesn't need to be unpacked.
                        },

                        total: function (data) {


                            if (Array.isArray(data)) {

                                if (parseResponseMethod != null) {

                                    return parseResponseMethod.total(data);
                                }

                                return data.length
                            } 

                            if (parseResponseMethod != null) {

                                return parseResponseMethod.total(data);
                            }

                            return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.

                        }
                        ,

                        model: {
                            id: modelID,//this ensures correct editing and deleting when using kewndo grid editing mode
                            fields: fields
                        },

                      
                    },
                    
                };
            
            if (group != null) {
                this.data.group = group;
            }
        }
        else if (isWithPaging == false) {
            this.data = {
                type: "odata-v4",
                serverFiltering: true,
                serverPaging: true,
                serverSorting: true,
                transport: {
                    read: {
                        url: url,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        xhrFields: {
                            withCredentials: true
                        },
                        beforeSend: function (xhr) {//Token                        
                            var token = "";
                            xhr.withCredentials = true;
                            if (storage.getItem('Token') != null)
                                token = storage.getItem('Token').Value;
                            xhr.setRequestHeader('Authentication', token);

                        }
                    },
                    parameterMap: function (options) {
                        if (!isListMode) {
                            for (var z = 0; z < DDlFilterParams.length; z++) {
                                options.filter.filters.push({
                                    "value": DDlFilterParams[z].value,
                                    "operator": DDlFilterParams[z].operator,
                                    "field": DDlFilterParams[z].field,
                                    "ignoreCase": "true"
                                });
                            }
                        }
                        if (!options.sort)
                            options.sort = [{ field: sortField, dir: sortType }];
                        else if (options.sort.length == 0)
                            options.sort.push({ field: sortField, dir: sortType });
                        var paramMap = kendo.data.transports.odata.parameterMap(options);
                        delete paramMap.$inlinecount; // <-- remove inlinecount parameter.
                        //To Allow Grid Filtring where it search with "Substring" Keyword and Odata  understand only "contains" Keyword so 
                        //this lines will loop for filters and replace itv with  the correct formate
                        if (paramMap.$filter) {

                            paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
                                return x.substring(1, x.length - 1);
                            });

                            var Params = paramMap.$filter.split(" and ");
                            paramMap.$filter = "";
                            for (var i = 0; i < Params.length; i++) {
                                var field = options.filter.filters[i].field;
                                var datefilter = Params[i].split("datetime'");
                                if (datefilter.length > 1) {
                                    for (var j = 0; j < datefilter.length; j++) {
                                        if (j == datefilter.length - 1) {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", ".000Z");
                                            //paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", timeZoneOffset);
                                        }
                                        else {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace(field, "cast(" + field + ",'Edm.DateTimeOffset')");
                                        }
                                    }
                                }
                                else {
                                    paramMap.$filter = paramMap.$filter + Params[i].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
                                }
                                if (i != Params.length - 1) {
                                    paramMap.$filter = paramMap.$filter + " and ";
                                }
                            }
                        }
                        return paramMap;

                    },
                },
                error: function (e) {
                    var xhr = e.xhr;
                    //var statusCode = e.status;
                    //var errorThrown = e.errorThrown;
                    if (xhr.status == 422) {                        
                        if (xhr.getAllResponseHeaders().toLowerCase().indexOf('sessionexpire') > -1) {//expired token and not authorized                            
                            EventBus.$emit('InternalServerError', xhr.statusText);
                            localStorage.clear();
                            router.push('/');
                        }
                        else {
                            router.push('/401');
                        }
                    }
                    else if (xhr.status == 500) {
                        // $state.go("app.error");
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 0) {
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 205) {
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 401) {
                        router.push('/401');
                    }
                    else {
                        console.log(xhr.status);

                        // toaster.error($translate.instant("common.ERROROccurred"));
                    }

                },
                schema: {

                    data: function (data) {

                        if (parseResponseMethod != null) {

                            return parseResponseMethod(data.value);
                        }


                        return data.value; // <-- The result is just the data, it doesn't need to be unpacked.
                    },

                    total: function (data) {
                        return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.

                    }
                    ,

                    model: {
                        id: modelID,//this ensures correct editing and deleting when using kewndo grid editing mode
                        fields: fields
                    }

                },

            };

            if (group != null) {
                this.data.group = group;
            }
        }
    }
}

export class KendoServiceDefaultParam {

    constructor(url, pageSize, modelID, fields, defaultParam, sortField, isWithPaging = true, sortType = "desc", isListMode = true, DDlFilterParams) {
        if (url.includes('?'))
            url = url + "&$count=true";
        else
            url = url + "?$count=true";
        if (isWithPaging) {

            this.data = {
                type: "odata-v4",
                serverFiltering: true,
                serverPaging: true,
                serverSorting: true,
                pageSize: pageSize,
                transport: {
                    read: {
                        url: url,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        xhrFields: {
                            withCredentials: true
                        },
                        beforeSend: function (xhr) {//Token                        
                            xhr.withCredentials = true;
                            var token = "";
                            if (storage.getItem('Token') != null)
                                token = storage.getItem('Token').Value;
                            xhr.setRequestHeader('Authentication', token);

                        }
                    },
                    parameterMap: function (options) {
                        if (!isListMode) {
                            for (var z = 0; z < DDlFilterParams.length; z++) {
                                options.filter.filters.push({
                                    "value": DDlFilterParams[z].value,
                                    "operator": DDlFilterParams[z].operator,
                                    "field": DDlFilterParams[z].field,
                                    "ignoreCase": "true"
                                });
                            }

                        }
                        //if (defaultParam) {
                        //    
                        //    options.filter.filters.push({
                        //        "value": defaultParam.value,
                        //        "operator": defaultParam.operator,
                        //        "field": defaultParam.field,
                        //        "ignoreCase": "true"
                        //    });
                        //}
                        if (!options.sort)
                            options.sort = [{ field: sortField, dir: sortType }];
                        else if (options.sort.length == 0)
                            options.sort.push({ field: sortField, dir: sortType });
                        var paramMap = kendo.data.transports.odata.parameterMap(options);
                        delete paramMap.$inlinecount; // <-- remove inlinecount parameter.
                        //To Allow Grid Filtring where it search with "Substring" Keyword and Odata  understand only "contains" Keyword so 
                        //this lines will loop for filters and replace itv with  the correct formate
                        if (!paramMap.$filter) {
                            paramMap.$filter = defaultParam.field + " " + defaultParam.operator + " " + defaultParam.value
                        }
                        else {
                            paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
                                return x.substring(1, x.length - 1);
                            });

                            var Params = paramMap.$filter.split(" and ");
                            paramMap.$filter = "";
                            for (var i = 0; i < Params.length; i++) {
                                var field = options.filter.filters[i].field;
                                var datefilter = Params[i].split("datetime'");
                                if (datefilter.length > 1) {
                                    for (var j = 0; j < datefilter.length; j++) {
                                        if (j == datefilter.length - 1) {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", ".000Z");
                                            //paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", timeZoneOffset);
                                        }
                                        else {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace(field, "cast(" + field + ",'Edm.DateTimeOffset')");
                                        }
                                    }
                                }
                                else {
                                    paramMap.$filter = paramMap.$filter + Params[i].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
                                }
                                if (i != Params.length - 1) {
                                    paramMap.$filter = paramMap.$filter + " and ";
                                }
                            }

                            paramMap.$filter = paramMap.$filter + " and " + defaultParam.field + " " + defaultParam.operator + " " + defaultParam.value
                        }

                        return paramMap;

                    },
                },
                error: function (e) {

                    var xhr = e.xhr;

                    //var statusCode = e.status;
                    //var errorThrown = e.errorThrown;
                    if (xhr.status == 422) {                        
                        if (xhr.getAllResponseHeaders().toLowerCase().indexOf('sessionexpire') > -1) {//expired token and not authorized                            
                            EventBus.$emit('InternalServerError', xhr.statusText);
                            localStorage.clear();
                            router.push('/');
                        }
                        else {
                            router.push('/401');
                        }
                    }
                    else if (xhr.status == 500) {
                        // $state.go("app.error");
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 0) {
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 205) {
                        console.log(xhr.status);

                    }
                    else if (xhr.responseText != null && xhr.responseText.includes("StatusCode: 401")) {
                        //window.location.href = backOfficeUrl + "401";
                        router.push('/401');
                    }

                    else {
                        console.log(xhr.status);
                    }

                },
                schema: {

                    data: function (data) {

                        return data.value; // <-- The result is just the data, it doesn't need to be unpacked.
                    },

                    total: function (data) {
                        return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.

                    }
                    ,

                    model: {
                        id: modelID,//this ensures correct editing and deleting when using kewndo grid editing mode
                        fields: fields
                    }

                },

            };

        }
        else if (isWithPaging == false) {
            this.data = {
                type: "odata-v4",
                serverFiltering: true,
                serverPaging: true,
                serverSorting: true,
                transport: {
                    read: {
                        url: url,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        xhrFields: {
                            withCredentials: true
                        },
                        beforeSend: function (xhr) {//Token                        
                            xhr.withCredentials = true;
                            var token = "";
                            if (storage.getItem('Token') != null)
                                token = storage.getItem('Token').Value;
                            xhr.setRequestHeader('Authentication', token);

                        }
                    },
                    parameterMap: function (options) {
                        if (!isListMode) {
                            for (var z = 0; z < DDlFilterParams.length; z++) {
                                options.filter.filters.push({
                                    "value": DDlFilterParams[z].value,
                                    "operator": DDlFilterParams[z].operator,
                                    "field": DDlFilterParams[z].field,
                                    "ignoreCase": "true"
                                });
                            }
                        }
                        if (!options.sort)
                            options.sort = [{ field: sortField, dir: sortType }];
                        else if (options.sort.length == 0)
                            options.sort.push({ field: sortField, dir: sortType });
                        var paramMap = kendo.data.transports.odata.parameterMap(options);
                        delete paramMap.$inlinecount; // <-- remove inlinecount parameter.
                        //To Allow Grid Filtring where it search with "Substring" Keyword and Odata  understand only "contains" Keyword so 
                        //this lines will loop for filters and replace itv with  the correct formate
                        if (paramMap.$filter) {

                            paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
                                return x.substring(1, x.length - 1);
                            });

                            var Params = paramMap.$filter.split(" and ");
                            paramMap.$filter = "";
                            for (var i = 0; i < Params.length; i++) {
                                var field = options.filter.filters[i].field;
                                var datefilter = Params[i].split("datetime'");
                                if (datefilter.length > 1) {
                                    for (var j = 0; j < datefilter.length; j++) {
                                        if (j == datefilter.length - 1) {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", ".000Z");
                                            //paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", timeZoneOffset);

                                        }
                                        else {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace(field, "cast(" + field + ",'Edm.DateTimeOffset')");
                                        }
                                    }
                                }
                                else {
                                    paramMap.$filter = paramMap.$filter + Params[i].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
                                }
                                if (i != Params.length - 1) {
                                    paramMap.$filter = paramMap.$filter + " and ";
                                }
                            }
                        }
                        return paramMap;

                    },
                },
                error: function (e) {
                    var xhr = e.xhr;
                    //var statusCode = e.status;
                    //var errorThrown = e.errorThrown;
                    if (xhr.status == 422) {                        
                        if (xhr.getAllResponseHeaders().toLowerCase().indexOf('sessionexpire') > -1) {//expired token and not authorized         
                            EventBus.$emit('InternalServerError', xhr.statusText);
                            localStorage.clear();
                            router.push('/');
                        }
                        else {
                            router.push('/401');
                        }
                    }
                    else if (xhr.status == 500) {
                        // $state.go("app.error");
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 0) {
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 205) {
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 401) {
                        window.location.href = "http://localhost:3000/" + "401";
                    }
                    else {
                        console.log(xhr.status);

                        // toaster.error($translate.instant("common.ERROROccurred"));
                    }

                },
                schema: {

                    data: function (data) {

                        return data.value; // <-- The result is just the data, it doesn't need to be unpacked.
                    },

                    total: function (data) {
                        return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.

                    }
                    ,

                    model: {
                        id: modelID,//this ensures correct editing and deleting when using kewndo grid editing mode
                        fields: fields
                    }

                },

            };

        }
    }
}

export class KendoServiceForWorkList {

    constructor(url, pageSize, modelID, fields, sortField, isWithPaging = true, sortType = "desc", isListMode = true, DDlFilterParams, parameterMapExtendedOptions) {


        if (url.includes('?'))
            url = url + "&$count=true";
        else
            url = url + "?$count=true";
        if (isWithPaging) {
            this.data = {
                type: "odata-v4",
                serverFiltering: true,
                serverPaging: true,
                serverSorting: true,
                pageSize: pageSize,
                transport: {
                    read: {
                        url: url,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        xhrFields: {
                            withCredentials: true
                        },
                        beforeSend: function (xhr) {//Token                        
                            xhr.withCredentials = true;
                            var token = "";
                            if (storage.getItem('Token') != null)
                                token = storage.getItem('Token').Value;
                            xhr.setRequestHeader('Authentication', token);

                        }
                    },
                    parameterMap: function (options) {

                        if (!isListMode) {
                            for (var z = 0; z < DDlFilterParams.length; z++) {
                                options.filter.filters.push({
                                    "value": DDlFilterParams[z].value,
                                    "operator": DDlFilterParams[z].operator,
                                    "field": DDlFilterParams[z].field,
                                    "ignoreCase": "true"
                                });
                            }

                        }
                        if (!options.sort)
                            options.sort = [{ field: sortField, dir: sortType }];
                        else if (options.sort.length == 0)
                            options.sort.push({ field: sortField, dir: sortType });

                        if (options && options.filter && options.filter.filters && options.filter.filters.length > 0 && options.filter.filters[0].field == "PatientInfo") {
                            options.filter.filters[0].field = "PatientCode";
                            //var yy= Object.assign({}, options.filter.filters[0]);
                            options.filter.filters.push(Object.assign({}, options.filter.filters[0]))
                            options.filter.filters[1].field = "PatientName";
                            //options.filter.logic="OR";
                        }

                        var paramMap = kendo.data.transports.odata.parameterMap(options);
                        delete paramMap.$inlinecount; // <-- remove inlinecount parameter.
                        //To Allow Grid Filtring where it search with "Substring" Keyword and Odata  understand only "contains" Keyword so 
                        //this lines will loop for filters and replace itv with  the correct formate
                        if (paramMap.$filter) {

                            paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
                                return x.substring(1, x.length - 1);
                            });

                            var Params = paramMap.$filter.split(" and ");
                            paramMap.$filter = "";
                            for (var i = 0; i < Params.length; i++) {
                                var field = options.filter.filters[i].field;
                                var datefilter = Params[i].split("OrderlineInstanceStartDatetime'");
                                if (datefilter.length > 1) {
                                    for (var j = 0; j < datefilter.length; j++) {
                                        if (j == datefilter.length - 1) {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", ".000Z");
                                        }
                                        else {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace(field, "cast(" + field + ",'Edm.DateTimeOffset')");
                                        }
                                    }
                                }
                                else {
                                    paramMap.$filter = paramMap.$filter + Params[i].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
                                }
                                if (i != Params.length - 1) {
                                    paramMap.$filter = paramMap.$filter + " and ";
                                }
                            }
                        }

                        if (parameterMapExtendedOptions) {
                            paramMap = Object.assign({}, paramMap, parameterMapExtendedOptions)
                        }

                        return paramMap;

                    },
                },
                error: function (e) {

                    var xhr = e.xhr;

                    //var statusCode = e.status;
                    //var errorThrown = e.errorThrown;
                    if (xhr.status == 422) {
                        if (xhr.getAllResponseHeaders().toLowerCase().indexOf('sessionexpire') > -1) {//expired token and not authorized
                            EventBus.$emit('InternalServerError', xhr.status + ": " + xhr.responseText);
                            localStorage.clear();
                            router.push('/');
                        }
                        else {
                            router.push('/401');
                        }

                        console.log(xhr.status);
                    }
                    else if (xhr.status == 500) {
                        EventBus.$emit('InternalServerError', '');

                    }
                    else if (xhr.status == 0) {
                        router.push('/dashboard');

                    }
                    else if (xhr.status == 205) {
                        localStorage.clear();
                        router.push('/');

                    }
                    else if (xhr.status == 401 || xhr.responseText.includes("StatusCode: 401")) {
                        router.push('/401');
                    }
                    else {
                        EventBus.$emit('InternalServerError', '');

                        // toaster.error($translate.instant("common.ERROROccurred"));
                    }

                },
                schema: {

                    data: function (data) {

                        return data.value; // <-- The result is just the data, it doesn't need to be unpacked.
                    },

                    total: function (data) {
                        return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.

                    }
                    ,

                    model: {
                        id: modelID,//this ensures correct editing and deleting when using kewndo grid editing mode
                        fields: fields
                    }

                },

            };

        }
        else if (isWithPaging == false) {
            this.data = {
                type: "odata-v4",
                serverFiltering: true,
                serverPaging: true,
                serverSorting: true,
                transport: {
                    read: {
                        url: url,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        xhrFields: {
                            withCredentials: true
                        },
                        beforeSend: function (xhr) {//Token                        
                            xhr.withCredentials = true;
                            var token = "";
                            if (storage.getItem('Token') != null)
                                token = storage.getItem('Token').Value;
                            xhr.setRequestHeader('Authentication', token);

                        }
                    },
                    parameterMap: function (options) {
                        if (!isListMode) {
                            for (var z = 0; z < DDlFilterParams.length; z++) {
                                options.filter.filters.push({
                                    "value": DDlFilterParams[z].value,
                                    "operator": DDlFilterParams[z].operator,
                                    "field": DDlFilterParams[z].field,
                                    "ignoreCase": "true"
                                });
                            }
                        }
                        if (!options.sort)
                            options.sort = [{ field: sortField, dir: sortType }];
                        else if (options.sort.length == 0)
                            options.sort.push({ field: sortField, dir: sortType });
                        var paramMap = kendo.data.transports.odata.parameterMap(options);
                        delete paramMap.$inlinecount; // <-- remove inlinecount parameter.
                        //To Allow Grid Filtring where it search with "Substring" Keyword and Odata  understand only "contains" Keyword so 
                        //this lines will loop for filters and replace itv with  the correct formate
                        if (paramMap.$filter) {

                            paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
                                return x.substring(1, x.length - 1);
                            });

                            var Params = paramMap.$filter.split(" and ");
                            paramMap.$filter = "";
                            for (var i = 0; i < Params.length; i++) {
                                var field = options.filter.filters[i].field;
                                var datefilter = Params[i].split("datetime'");
                                if (datefilter.length > 1) {
                                    for (var j = 0; j < datefilter.length; j++) {
                                        if (j == datefilter.length - 1) {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", ".000Z");
                                        }
                                        else {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace(field, "cast(" + field + ",'Edm.DateTimeOffset')");
                                        }
                                    }
                                }
                                else {
                                    paramMap.$filter = paramMap.$filter + Params[i].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
                                }
                                if (i != Params.length - 1) {
                                    paramMap.$filter = paramMap.$filter + " and ";
                                }
                            }
                        }
                        return paramMap;

                    },
                },
                error: function (e) {
                    var xhr = e.xhr;
                    //var statusCode = e.status;
                    //var errorThrown = e.errorThrown;
                    if (xhr.status == 422) {
                        if (xhr.getAllResponseHeaders().toLowerCase().indexOf('sessionexpire') > -1) {//expired token and not authorized
                            EventBus.$emit('InternalServerError', xhr.status + ": " + xhr.responseText);
                            localStorage.clear();
                            router.push('/');
                        }
                        else {
                            router.push('/401');
                        }

                        console.log(xhr.status);
                    }
                    else if (xhr.status == 500) {
                        EventBus.$emit('InternalServerError', '');

                    }
                    else if (xhr.status == 0) {
                        router.push('/dashboard');

                    }
                    else if (xhr.status == 205) {
                        localStorage.clear();
                        router.push('/');

                    }
                    else if (xhr.status == 401 || xhr.responseText.includes("StatusCode: 401")) {
                        router.push('/401');
                    }
                    else {
                        EventBus.$emit('InternalServerError', '');

                        // toaster.error($translate.instant("common.ERROROccurred"));
                    }

                },
                schema: {

                    data: function (data) {

                        return data.value; // <-- The result is just the data, it doesn't need to be unpacked.
                    },

                    total: function (data) {
                        return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.

                    }
                    ,

                    model: {
                        id: modelID,//this ensures correct editing and deleting when using kewndo grid editing mode
                        fields: fields
                    }

                },

            };

        }
    }
}

export class KendoServiceForPatientSearch {
    // isListMode = true, DDlFilterParams,
    constructor(url, pageSize, modelID, fields, sortField, isWithPaging = true, sortType = "desc", parameterMapExtendedOptions) {

        if (url.includes('?'))
            url = url + "&$count=true";
        else
            url = url + "?$count=true";
        if (isWithPaging) {
            this.data = {
                type: "odata-v4",
                serverFiltering: true,
                serverPaging: true,
                serverSorting: true,
                pageSize: pageSize,
                transport: {
                    read: {
                        url: url,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        xhrFields: {
                            withCredentials: true
                        },
                        beforeSend: function (xhr) {//Token                        
                            xhr.withCredentials = true;
                            var token = "";
                            if (storage.getItem('Token') != null)
                                token = storage.getItem('Token').Value;
                            xhr.setRequestHeader('Authentication', token);

                        }
                    },
                    parameterMap: function (options) {
                        
                        // if (!isListMode) {
                        //     for (var z = 0; z < DDlFilterParams.length; z++) {
                        //         options.filter.filters.push({
                        //             "value": DDlFilterParams[z].value,
                        //             "operator": DDlFilterParams[z].operator,
                        //             "field": DDlFilterParams[z].field,
                        //             "ignoreCase": "true"
                        //         });
                        //     }

                        // }
                        if (!options.sort)
                            options.sort = [{ field: sortField, dir: sortType }];
                        else if (options.sort.length == 0)
                            options.sort.push({ field: sortField, dir: sortType });

                        // if (options && options.filter && options.filter.filters && options.filter.filters.length > 0 && options.filter.filters[0].field == "PatientInfo") {
                        //     options.filter.filters[0].field = "PatientCode";
                        //     //var yy= Object.assign({}, options.filter.filters[0]);
                        //     options.filter.filters.push(Object.assign({}, options.filter.filters[0]))
                        //     options.filter.filters[1].field = "PatientName";
                        //     //options.filter.logic="OR";
                        // }

                        var paramMap = kendo.data.transports.odata.parameterMap(options);
                        delete paramMap.$inlinecount; // <-- remove inlinecount parameter.
                        //To Allow Grid Filtring where it search with "Substring" Keyword and Odata  understand only "contains" Keyword so 
                        //this lines will loop for filters and replace itv with  the correct formate
                        // if (paramMap.$filter) {

                        //     paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
                        //         return x.substring(1, x.length - 1);
                        //     });

                        //     var Params = paramMap.$filter.split(" and ");
                        //     paramMap.$filter = "";
                        //     for (var i = 0; i < Params.length; i++) {
                        //         var field = options.filter.filters[i].field;
                        //         var datefilter = Params[i].split("OrderlineInstanceStartDatetime'");
                        //         if (datefilter.length > 1) {
                        //             for (var j = 0; j < datefilter.length; j++) {
                        //                 if (j == datefilter.length - 1) {
                        //                     paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", ".000Z");
                        //                 }
                        //                 else {
                        //                     paramMap.$filter = paramMap.$filter + datefilter[j].replace(field, "cast(" + field + ",'Edm.DateTimeOffset')");
                        //                 }
                        //             }
                        //         }
                        //         else {
                        //             paramMap.$filter = paramMap.$filter + Params[i].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
                        //         }
                        //         if (i != Params.length - 1) {
                        //             paramMap.$filter = paramMap.$filter + " and ";
                        //         }
                        //     }
                        // }

                        if (parameterMapExtendedOptions) {
                            paramMap = Object.assign({}, paramMap, parameterMapExtendedOptions)
                        }

                        return paramMap;

                    },
                },
                error: function (e) {

                    var xhr = e.xhr;

                    //var statusCode = e.status;
                    //var errorThrown = e.errorThrown;
                    if (xhr.status == 422) {
                        if (xhr.getAllResponseHeaders().toLowerCase().indexOf('sessionexpire') > -1) {//expired token and not authorized    
                            EventBus.$emit('InternalServerError', xhr.statusText);
                            localStorage.clear();
                            router.push('/');
                        }
                        else {
                            router.push('/401');
                        }
                    }
                    else if (xhr.status == 500) {
                        // $state.go("app.error");
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 0) {
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 205) {
                        console.log(xhr.status);

                    }
                    else if (xhr.responseText != null && xhr.responseText.includes("StatusCode: 401")) {
                        //window.location.href = backOfficeUrl + "401";
                        router.push('/401');
                    }

                    else {
                        console.log(xhr.status);
                    }

                },
                schema: {

                    data: function (data) {

                        return data.value; // <-- The result is just the data, it doesn't need to be unpacked.
                    },

                    total: function (data) {
                        return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.

                    }
                    ,

                    model: {
                        id: modelID,//this ensures correct editing and deleting when using kewndo grid editing mode
                        fields: fields
                    }

                },

            };

        }
        // else if (isWithPaging == false) {
        //     this.data = {
        //         type: "odata-v4",
        //         serverFiltering: true,
        //         serverPaging: true,
        //         serverSorting: true,
        //         transport: {
        //             read: {
        //                 url: url,
        //                 contentType: "application/json; charset=utf-8",
        //                 dataType: "json",
        //                 //xhrFields: {
        //                 //    withCredentials: true
        //                 //},
        //                 beforeSend: function (xhr) {//Token                        
        //                     var token = "";
        //                     if (storage.getItem('Token') != null)
        //                         token = storage.getItem('Token').Value;
        //                     xhr.setRequestHeader('Authentication', token);

        //                 }
        //             },
        //             parameterMap: function (options) {
        //                 if (!isListMode) {
        //                     for (var z = 0; z < DDlFilterParams.length; z++) {
        //                         options.filter.filters.push({
        //                             "value": DDlFilterParams[z].value,
        //                             "operator": DDlFilterParams[z].operator,
        //                             "field": DDlFilterParams[z].field,
        //                             "ignoreCase": "true"
        //                         });
        //                     }
        //                 }
        //                 if (!options.sort)
        //                     options.sort = [{ field: sortField, dir: sortType }];
        //                 else if (options.sort.length == 0)
        //                     options.sort.push({ field: sortField, dir: sortType });
        //                 var paramMap = kendo.data.transports.odata.parameterMap(options);
        //                 delete paramMap.$inlinecount; // <-- remove inlinecount parameter.
        //                 //To Allow Grid Filtring where it search with "Substring" Keyword and Odata  understand only "contains" Keyword so 
        //                 //this lines will loop for filters and replace itv with  the correct formate
        //                 if (paramMap.$filter) {

        //                     paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
        //                         return x.substring(1, x.length - 1);
        //                     });

        //                     var Params = paramMap.$filter.split(" and ");
        //                     paramMap.$filter = "";
        //                     for (var i = 0; i < Params.length; i++) {
        //                         var field = options.filter.filters[i].field;
        //                         var datefilter = Params[i].split("datetime'");
        //                         if (datefilter.length > 1) {
        //                             for (var j = 0; j < datefilter.length; j++) {
        //                                 if (j == datefilter.length - 1) {
        //                                     paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", ".000Z");
        //                                 }
        //                                 else {
        //                                     paramMap.$filter = paramMap.$filter + datefilter[j].replace(field, "cast(" + field + ",'Edm.DateTimeOffset')");
        //                                 }
        //                             }
        //                         }
        //                         else {
        //                             paramMap.$filter = paramMap.$filter + Params[i].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
        //                         }
        //                         if (i != Params.length - 1) {
        //                             paramMap.$filter = paramMap.$filter + " and ";
        //                         }
        //                     }
        //                 }
        //                 return paramMap;

        //             },
        //         },
        //         error: function (e) {
        //             var xhr = e.xhr;
        //             //var statusCode = e.status;
        //             //var errorThrown = e.errorThrown;
        //             if (xhr.status == 422) {
        //                 console.log(xhr.status);
        //             }
        //             else if (xhr.status == 500) {
        //                 // $state.go("app.error");
        //                 console.log(xhr.status);

        //             }
        //             else if (xhr.status == 0) {
        //                 console.log(xhr.status);

        //             }
        //             else if (xhr.status == 205) {
        //                 console.log(xhr.status);

        //             }
        //             else if (xhr.status == 401) {
        //                 window.location.href = "http://localhost:3000/" + "401";
        //             }
        //             else {
        //                 console.log(xhr.status);

        //                 // toaster.error($translate.instant("common.ERROROccurred"));
        //             }

        //         },
        //         schema: {

        //             data: function (data) {

        //                 return data.value; // <-- The result is just the data, it doesn't need to be unpacked.
        //             },

        //             total: function (data) {
        //                 return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.

        //             }
        //             ,

        //             model: {
        //                 id: modelID,//this ensures correct editing and deleting when using kewndo grid editing mode
        //                 fields: fields
        //             }

        //         },

        //     };

        // }
    }
}

export class KendoServiceForCustomParams {
    constructor(URL, pageSize, modelId, fields, sortField, sortType = "desc", isListMode = true, DDlFilterParams, optionalParameterFilterLst, serverOperations) {
        
        if (serverOperations == undefined)
            serverOperations = true;
        if (URL.includes('?'))
            URL = URL + "&$count=true";
        else
            URL = URL + "?$count=true";

        this.data = new kendo.data.DataSource({
            type: "odata-v4",
            pageSize: pageSize,
            serverPaging: serverOperations,
            serverFiltering: serverOperations,
            serverSorting: serverOperations,
            error: function (e) {
                var xhr = e.xhr;

                //var statusCode = e.status;
                //var errorThrown = e.errorThrown;
                if (xhr.status == 422) {
                    if (xhr.getAllResponseHeaders().toLowerCase().indexOf('sessionexpire') > -1) {//expired token and not authorized                            
                        EventBus.$emit('InternalServerError', xhr.statusText);
                        localStorage.clear();
                        router.push('/');
                    }
                    else {
                        router.push('/401');
                    }
                }
                else if (xhr.status == 500) {
                    // $state.go("app.error");
                    console.log(xhr.status);

                }
                else if (xhr.status == 0) {
                    console.log(xhr.status);

                }
                else if (xhr.status == 205) {
                    console.log(xhr.status);

                }
                else if (xhr.responseText != null && xhr.responseText.includes("StatusCode: 401")) {
                    //window.location.href = backOfficeUrl + "401";
                    router.push('/401');
                }

                else {
                    console.log(xhr.status);
                }
            },
            transport: {

                read: {
                    // async: false,

                    //OData Controller URL
                    url: URL,// + "&$count=true",
                    dataType: "json",
                    xhrFields: {
                        withCredentials: true
                    },
                    beforeSend: function (xhr) {//Token   
                        xhr.withCredentials = true;
                        var token = "";
                        if (storage.getItem('Token') != null)
                            token = storage.getItem('Token').Value;
                        xhr.setRequestHeader('Authentication', token);

                    }
                },
                parameterMap: function (options) {
                    
                    options.filter = {};
                    options.filter.logic = "or";
                    options.filter.filters = [];
                    var paramMap = "";
                    var z = 0;
                    var j = 0;
                    var Params = "";
                    var paramtersProceeds = "";

                    if (!isListMode) {

                        if (optionalParameterFilterLst, length > 0) {
                            for (z = 0; z < optionalParameterFilterLst.length; z++) {
                                options.filter.filters.push({
                                    "value": optionalParameterFilterLst[z].value,
                                    "operator": optionalParameterFilterLst[z].operator,
                                    "field": optionalParameterFilterLst[z].field,
                                    "ignoreCase": "true"
                                });
                            }

                            paramMap = kendo.data.transports.odata.parameterMap(options);
                            delete paramMap.$inlinecount; // <-- remove inlinecount parameter.

                            /////////////////////////////////////
                            if (paramMap.$filter) {
                                paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig,
                                    function (x) {
                                        return x.substring(1, x.length - 1);
                                    });
                                Params = paramMap.$filter.split(" or ");
                                paramMap.$filter = "";
                                for (j = 0; j < Params.length; j++) {
                                    if (Params.length == 1 || j == Params.length - 1) {
                                        paramMap.$filter = paramMap.$filter + Params[j].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
                                    }
                                    else {
                                        paramMap.$filter = paramMap.$filter + Params[j].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))") + " or ";
                                    }
                                }
                                paramMap.$filter = paramMap.$filter.replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
                            }

                            paramtersProceeds = paramMap.$filter;
                            options.filter.logic = "and";
                            options.filter.filters = [];
                        }


                        for (z = 0; z < DDlFilterParams.length; z++) {
                            options.filter.filters.push({
                                "value": DDlFilterParams[z].value,
                                "operator": DDlFilterParams[z].operator,
                                "field": DDlFilterParams[z].field,
                                "ignoreCase": "true"
                            });

                        }
                    }
                    if (sortField) {
                        if (!options.sort)
                            options.sort = [{ field: sortField, dir: sortType }];
                        else if (options.sort.length == 0)
                            options.sort.push({ field: sortField, dir: sortType });
                    }
                    paramMap = kendo.data.transports.odata.parameterMap(options);
                    delete paramMap.$inlinecount; // <-- remove inlinecount parameter.


                    if (!paramMap.$filter) {
                        if (paramtersProceeds) {
                            paramMap.$filter = paramtersProceeds;
                        }
                    }
                    else {
                        paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
                            return x.substring(1, x.length - 1);
                        });

                        Params = paramMap.$filter.split(" and ");
                        paramMap.$filter = "";
                        for (var i = 0; i < Params.length; i++) {
                            var field = options.filter.filters[i].field;
                            var datefilter = Params[i].split("datetime'");
                            if (datefilter.length > 1) {
                                for (j = 0; j < datefilter.length; j++) {
                                    if (j == datefilter.length - 1) {
                                        paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", ".000Z");
                                    }
                                    else {
                                        paramMap.$filter = paramMap.$filter + datefilter[j].replace(field, "cast(" + field + ",'Edm.DateTimeOffset')");
                                    }
                                }
                            }
                            else {
                                paramMap.$filter = paramMap.$filter + Params[i].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
                            }
                            if (i != Params.length - 1) {
                                paramMap.$filter = paramMap.$filter + " and ";
                            }
                        }
                        

                        if (paramtersProceeds && paramMap.$filter) {
                            paramMap.$filter = paramtersProceeds + " and " + paramMap.$filter;
                            paramtersProceeds = paramMap.$filter;

                        }
                        else if (paramtersProceeds) {
                            paramMap.$filter = paramtersProceeds;
                        }

                    }
                    

                    return paramMap;

                },
            },
            //requestEnd: requestEnd,
            schema: {
                data: function (data) {

                    return data.value; // <-- The result is just the data, it doesn't need to be unpacked.
                },
                total: function (data) {
                    return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.
                }
                ,

                model: {
                    id: modelId,//this ensures correct editing and deleting when using kewndo grid editing mode
                    fields: fields
                }

            }
        })

    }
}
export class KendoServiceWithFilter {

    constructor(url, pageSize, modelID, fields, sortField, isWithPaging = true, sortType = "desc", isListMode = true, DDlFilterParams, parameterMapExtendedOptions = null, SortCallBack = null) {
        if (url.includes('?'))
            url = url + "&$count=true";
        else
            url = url + "?$count=true";
        if (isWithPaging) {
            this.data = {
                type: "odata-v4",
                serverFiltering: true,
                serverPaging: true,
                serverSorting: true,
                pageSize: pageSize,
                transport: {
                    read: {
                        url: url,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        xhrFields: {
                            withCredentials: true
                        },
                        beforeSend: function (xhr) {//Token
                            xhr.withCredentials = true;
                            var token = "";
                            if (storage.getItem('Token') != null)
                                token = storage.getItem('Token').Value;
                            xhr.setRequestHeader('Authentication', token);

                        }
                    },
                    parameterMap: function (options) {
                        if (!isListMode) {
                            for (var z = 0; z < DDlFilterParams.length; z++) {
                                options.filter.filters.push({
                                    "value": DDlFilterParams[z].value,
                                    "operator": DDlFilterParams[z].operator,
                                    "field": DDlFilterParams[z].field,
                                    "ignoreCase": "true"
                                });
                            }

                        }

                        if (!options.sort)
                            options.sort = [{ field: sortField, dir: sortType }];
                        else if (options.sort.length == 0)
                            options.sort.push({ field: sortField, dir: sortType });

                        if (SortCallBack != null) {
                            SortCallBack(options);
                        }


                        var paramMap = kendo.data.transports.odata.parameterMap(options);
                        delete paramMap.$inlinecount; // <-- remove inlinecount parameter.
                        //To Allow Grid Filtring where it search with "Substring" Keyword and Odata  understand only "contains" Keyword so 
                        //this lines will loop for filters and replace itv with  the correct formate

                        if (paramMap.$filter) {

                            paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
                                return x.substring(1, x.length - 1);
                            });
                            var Params = paramMap.$filter.split(" and ");
                            paramMap.$filter = "";
                            for (var i = 0; i < Params.length; i++) {
                                var field = null;
                                if (options.filter.filters[i]) {
                                    if (options.filter.filters[i].logic) {
                                        if (i > 0 && options.filter.filters[i - 1].logic == "and") {
                                            field = options.filter.filters[i - 1].filters[0].field;
                                        } else {
                                            field = options.filter.filters[i].filters[0].field;
                                        }
                                    }
                                    else {
                                        field = options.filter.filters[i].field;
                                    }
                                }
                                else {
                                    if (options.filter.filters[i - 1].logic) {
                                        field = options.filter.filters[i - 1].filters[0].field;
                                    }
                                    else {
                                        field = options.filter.filters[i - 1].field;
                                    }
                                }

                                var datefilter = Params[i].split("datetime'");
                                if (datefilter.length > 1) {

                                    for (var j = 0; j < datefilter.length; j++) {
                                        if (j == datefilter.length - 1) {

                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", ".000Z");
                                            //paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", timeZoneOffset);
                                            //var timeZoneOffsetStr = GetTimeZoneOffsetString();
                                            //paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", "+02:00");
                                        }
                                        else {

                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace(field, "cast(" + field + ",'Edm.DateTimeOffset')");
                                        }
                                    }
                                }
                                else {
                                    if (Params[i].split('tolower').length > 1) {
                                        Params[i] = Params[i].replace('tolower(', "");
                                        Params[i] = Params[i].replace(')', "");
                                    } 
                                        paramMap.$filter = paramMap.$filter + Params[i].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
                                    
                                }
                                if (i != Params.length - 1) {
                                    paramMap.$filter = paramMap.$filter + " and ";
                                }
                            }
                        }

                        if (parameterMapExtendedOptions) {
                            paramMap = Object.assign({}, paramMap, parameterMapExtendedOptions)
                        }

                        return paramMap;

                    },
                },
                error: function (e) {

                    var xhr = e.xhr;

                    //var statusCode = e.status;
                    //var errorThrown = e.errorThrown;
                    if (xhr.status == 422) {
                        if (xhr.getAllResponseHeaders().toLowerCase().indexOf('sessionexpire') > -1) {//expired token and not authorized                            
                            EventBus.$emit('InternalServerError', xhr.statusText);
                            localStorage.clear();
                            router.push('/');
                        }
                        else {
                            router.push('/401');
                        }
                    }
                    else if (xhr.status == 500) {
                        // $state.go("app.error");
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 0) {
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 205) {
                        console.log(xhr.status);

                    }
                    else if (xhr.responseText != null && xhr.responseText.includes("StatusCode: 401")) {
                        //window.location.href = backOfficeUrl + "401";
                        router.push('/401');
                    }

                    else {
                        console.log(xhr.status);
                    }

                },
                schema: {

                    data: function (data) {

                        if (Array.isArray(data)) {
                            return data
                        }
                        return data.value; // <-- The result is just the data, it doesn't need to be unpacked.
                    },

                    total: function (data) {

                        if (Array.isArray(data)) {
                            return data.length
                        }
                        return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.

                    }
                    ,

                    model: {
                        id: modelID,//this ensures correct editing and deleting when using kewndo grid editing mode
                        fields: fields
                    }

                },

            };

        }
        else if (isWithPaging == false) {
            this.data = {
                type: "odata-v4",
                serverFiltering: true,
                serverPaging: true,
                serverSorting: true,
                transport: {
                    read: {
                        url: url,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        xhrFields: {
                            withCredentials: true
                        },
                        beforeSend: function (xhr) {//Token  
                            xhr.withCredentials = true;
                            var token = "";
                            if (storage.getItem('Token') != null)
                                token = storage.getItem('Token').Value;
                            xhr.setRequestHeader('Authentication', token);

                        }
                    },
                    parameterMap: function (options) {
                        if (!isListMode) {
                            for (var z = 0; z < DDlFilterParams.length; z++) {
                                options.filter.filters.push({
                                    "value": DDlFilterParams[z].value,
                                    "operator": DDlFilterParams[z].operator,
                                    "field": DDlFilterParams[z].field,
                                    "ignoreCase": "true"
                                });
                            }
                        }
                        if (!options.sort)
                            options.sort = [{ field: sortField, dir: sortType }];
                        else if (options.sort.length == 0)
                            options.sort.push({ field: sortField, dir: sortType });
                        var paramMap = kendo.data.transports.odata.parameterMap(options);
                        delete paramMap.$inlinecount; // <-- remove inlinecount parameter.
                        //To Allow Grid Filtring where it search with "Substring" Keyword and Odata  understand only "contains" Keyword so 
                        //this lines will loop for filters and replace itv with  the correct formate
                        if (paramMap.$filter) {

                            paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
                                return x.substring(1, x.length - 1);
                            });

                            var Params = paramMap.$filter.split(" and ");
                            paramMap.$filter = "";
                            for (var i = 0; i < Params.length; i++) {
                                var field = options.filter.filters[i].field;
                                var datefilter = Params[i].split("datetime'");
                                if (datefilter.length > 1) {
                                    for (var j = 0; j < datefilter.length; j++) {
                                        if (j == datefilter.length - 1) {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", ".000Z");
                                            //paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", timeZoneOffset);
                                        }
                                        else {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace(field, "cast(" + field + ",'Edm.DateTimeOffset')");
                                        }
                                    }
                                }
                                else {
                                    paramMap.$filter = paramMap.$filter + Params[i].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
                                }
                                if (i != Params.length - 1) {
                                    paramMap.$filter = paramMap.$filter + " and ";
                                }
                            }
                        }
                        return paramMap;

                    },
                },
                error: function (e) {
                    var xhr = e.xhr;
                    //var statusCode = e.status;
                    //var errorThrown = e.errorThrown;
                    if (xhr.status == 422) {
                        if (xhr.getAllResponseHeaders().toLowerCase().indexOf('sessionexpire') > -1) {//expired token and not authorized                            
                            EventBus.$emit('InternalServerError', xhr.statusText);
                            localStorage.clear();
                            router.push('/');
                        }
                        else {
                            router.push('/401');
                        }
                    }
                    else if (xhr.status == 500) {
                        // $state.go("app.error");
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 0) {
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 205) {
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 401) {
                        router.push('/401');
                    }
                    else {
                        console.log(xhr.status);

                        // toaster.error($translate.instant("common.ERROROccurred"));
                    }

                },
                schema: {

                    data: function (data) {

                        return data.value; // <-- The result is just the data, it doesn't need to be unpacked.
                    },

                    total: function (data) {
                        return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.

                    }
                    ,

                    model: {
                        id: modelID,//this ensures correct editing and deleting when using kewndo grid editing mode
                        fields: fields
                    }

                },

            };

        }
    }
}

export class KendoServicePatientProblemCustomParam {

    constructor(url, pageSize, modelID, fields, sortField, isWithPaging = true, sortType = "desc", isListMode = true, DDlFilterParams, parameterMapExtendedOptions = null, SortCallBack = null) {
        if (url.includes('?'))
            url = url + "&$count=true";
        else
            url = url + "?$count=true";
        if (isWithPaging) {
            this.data = {
                type: "odata-v4",
                serverFiltering: true,
                serverPaging: true,
                serverSorting: true,
                pageSize: pageSize,
                transport: {
                    read: {
                        url: url,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        xhrFields: {
                            withCredentials: true
                        },
                        beforeSend: function (xhr) {//Token  
                            xhr.withCredentials = true;
                            var token = "";
                            if (storage.getItem('Token') != null)
                                token = storage.getItem('Token').Value;
                            xhr.setRequestHeader('Authentication', token);

                        }
                    },
                    parameterMap: function (options) {
                        if (!isListMode) {
                            for (var z = 0; z < DDlFilterParams.length; z++) {
                                options.filter.filters.push({
                                    "value": DDlFilterParams[z].value,
                                    "operator": DDlFilterParams[z].operator,
                                    "field": DDlFilterParams[z].field,
                                    "ignoreCase": "true"
                                });
                            }

                        }

                        if (!options.sort)
                            options.sort = [{ field: sortField, dir: sortType }, { field: "CreationDate", dir: sortType }];
                        else if (options.sort.length == 0)
                            options.sort.push({ field: sortField, dir: sortType }, { field: "CreationDate", dir: sortType });


                        if (SortCallBack != null) {
                            SortCallBack(options);
                        }


                        var paramMap = kendo.data.transports.odata.parameterMap(options);
                        delete paramMap.$inlinecount; // <-- remove inlinecount parameter.
                        //To Allow Grid Filtring where it search with "Substring" Keyword and Odata  understand only "contains" Keyword so 
                        //this lines will loop for filters and replace itv with  the correct formate

                        if (paramMap.$filter) {

                            paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
                                return x.substring(1, x.length - 1);
                            });
                            var Params = paramMap.$filter.split(" and ");
                            paramMap.$filter = "";
                            for (var i = 0; i < Params.length; i++) {
                                var field = null;
                                if (options.filter.filters[i]) {
                                    if (options.filter.filters[i].logic) {
                                        if (i > 0 && options.filter.filters[i - 1].logic == "and") {
                                            field = options.filter.filters[i - 1].filters[0].field;
                                        } else {
                                            field = options.filter.filters[i].filters[0].field;
                                        }
                                    }
                                    else {
                                        field = options.filter.filters[i].field;
                                    }
                                }
                                else {
                                    if (options.filter.filters[i - 1].logic) {
                                        field = options.filter.filters[i - 1].filters[0].field;
                                    }
                                    else {
                                        field = options.filter.filters[i - 1].field;
                                    }
                                }

                                var datefilter = Params[i].split("datetime'");
                                if (datefilter.length > 1) {

                                    for (var j = 0; j < datefilter.length; j++) {
                                        if (j == datefilter.length - 1) {

                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", ".000Z");
                                            //paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", timeZoneOffset);
                                            //var timeZoneOffsetStr = GetTimeZoneOffsetString();
                                            //paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", "+02:00");
                                        }
                                        else {

                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace(field, "cast(" + field + ",'Edm.DateTimeOffset')");
                                        }
                                    }
                                }
                                else {
                                    paramMap.$filter = paramMap.$filter + Params[i].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
                                }
                                if (i != Params.length - 1) {
                                    paramMap.$filter = paramMap.$filter + " and ";
                                }
                            }
                        }

                        if (parameterMapExtendedOptions) {
                            paramMap = Object.assign({}, paramMap, parameterMapExtendedOptions)
                        }

                        return paramMap;

                    },
                },
                error: function (e) {

                    var xhr = e.xhr;

                    //var statusCode = e.status;
                    //var errorThrown = e.errorThrown;
                    if (xhr.status == 422) {
                        if (xhr.getAllResponseHeaders().toLowerCase().indexOf('sessionexpire') > -1) {//expired token and not authorized                            
                            EventBus.$emit('InternalServerError', xhr.statusText);
                            localStorage.clear();
                            router.push('/');
                        }
                        else {
                            router.push('/401');
                        }
                    }
                    else if (xhr.status == 500) {
                        // $state.go("app.error");
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 0) {
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 205) {
                        console.log(xhr.status);

                    }
                    else if (xhr.responseText != null && xhr.responseText.includes("StatusCode: 401")) {
                        //window.location.href = backOfficeUrl + "401";
                        router.push('/401');
                    }

                    else {
                        console.log(xhr.status);
                    }

                },
                schema: {

                    data: function (data) {

                        if (Array.isArray(data)) {
                            return data
                        }
                        return data.value; // <-- The result is just the data, it doesn't need to be unpacked.
                    },

                    total: function (data) {

                        if (Array.isArray(data)) {
                            return data.length
                        }
                        return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.

                    }
                    ,

                    model: {
                        id: modelID,//this ensures correct editing and deleting when using kewndo grid editing mode
                        fields: fields
                    }

                },

            };

        }
        else if (isWithPaging == false) {
            this.data = {
                type: "odata-v4",
                serverFiltering: true,
                serverPaging: true,
                serverSorting: true,
                transport: {
                    read: {
                        url: url,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        xhrFields: {
                            withCredentials: true
                        },
                        beforeSend: function (xhr) {//Token  
                            xhr.withCredentials = true;
                            var token = "";
                            if (storage.getItem('Token') != null)
                                token = storage.getItem('Token').Value;
                            xhr.setRequestHeader('Authentication', token);

                        }
                    },
                    parameterMap: function (options) {
                        if (!isListMode) {
                            for (var z = 0; z < DDlFilterParams.length; z++) {
                                options.filter.filters.push({
                                    "value": DDlFilterParams[z].value,
                                    "operator": DDlFilterParams[z].operator,
                                    "field": DDlFilterParams[z].field,
                                    "ignoreCase": "true"
                                });
                            }
                        }
                        if (!options.sort)
                            options.sort = [{ field: sortField, dir: sortType }, { field: "CreationDate", dir: sortType }];
                        else if (options.sort.length == 0)
                            options.sort.push({ field: sortField, dir: sortType }, { field: "CreationDate", dir: sortType });
                        var paramMap = kendo.data.transports.odata.parameterMap(options);
                        delete paramMap.$inlinecount; // <-- remove inlinecount parameter.
                        //To Allow Grid Filtring where it search with "Substring" Keyword and Odata  understand only "contains" Keyword so 
                        //this lines will loop for filters and replace itv with  the correct formate
                        if (paramMap.$filter) {

                            paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
                                return x.substring(1, x.length - 1);
                            });

                            var Params = paramMap.$filter.split(" and ");
                            paramMap.$filter = "";
                            for (var i = 0; i < Params.length; i++) {
                                var field = options.filter.filters[i].field;
                                var datefilter = Params[i].split("datetime'");
                                if (datefilter.length > 1) {
                                    for (var j = 0; j < datefilter.length; j++) {
                                        if (j == datefilter.length - 1) {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", ".000Z");
                                            //paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", timeZoneOffset);
                                        }
                                        else {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace(field, "cast(" + field + ",'Edm.DateTimeOffset')");
                                        }
                                    }
                                }
                                else {
                                    paramMap.$filter = paramMap.$filter + Params[i].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
                                }
                                if (i != Params.length - 1) {
                                    paramMap.$filter = paramMap.$filter + " and ";
                                }
                            }
                        }
                        return paramMap;

                    },
                },
                error: function (e) {
                    var xhr = e.xhr;
                    //var statusCode = e.status;
                    //var errorThrown = e.errorThrown;
                    if (xhr.status == 422) {
                        if (xhr.getAllResponseHeaders().toLowerCase().indexOf('sessionexpire') > -1) {//expired token and not authorized                            
                            EventBus.$emit('InternalServerError', xhr.statusText);
                            localStorage.clear();
                            router.push('/');
                        }
                        else {
                            router.push('/401');
                        }
                    }
                    else if (xhr.status == 500) {
                        // $state.go("app.error");
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 0) {
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 205) {
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 401) {
                        router.push('/401');
                    }
                    else {
                        console.log(xhr.status);

                        // toaster.error($translate.instant("common.ERROROccurred"));
                    }

                },
                schema: {

                    data: function (data) {

                        return data.value; // <-- The result is just the data, it doesn't need to be unpacked.
                    },

                    total: function (data) {
                        return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.

                    }
                    ,

                    model: {
                        id: modelID,//this ensures correct editing and deleting when using kewndo grid editing mode
                        fields: fields
                    }

                },

            };

        }
    }
}

// CustomSortingObject {"FieldName" : "SortFieldName",...]

export class SortableKendoService {
    constructor(url, pageSize, modelID, fields, sortField, isWithPaging = true, sortType = "desc", CustomSortingObject, isListMode = true, DDlFilterParams, parameterMapExtendedOptions = null, SortCallBack = null) {
        if (url.includes('?'))
            url = url + "&$count=true";
        else
            url = url + "?$count=true";

        if (isWithPaging) {

            this.data = {
                type: "odata-v4",
                serverFiltering: true,
                serverPaging: true,
                serverSorting: true,
                pageSize: pageSize,
                transport: {
                    read:
                    {
                        url: url,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        xhrFields: {
                            withCredentials: true
                        },
                        beforeSend: function (xhr) {//Token                        
                            xhr.withCredentials = true;
                            var token = "";

                            if (storage.getItem('Token') != null)
                                token = storage.getItem('Token').Value;
                            xhr.setRequestHeader('Authentication', token);

                        }
                    },
                    parameterMap: function (options) {
                        if (!isListMode) {
                            for (var z = 0; z < DDlFilterParams.length; z++) {
                                options.filter.filters.push({
                                    "value": DDlFilterParams[z].value,
                                    "operator": DDlFilterParams[z].operator,
                                    "field": DDlFilterParams[z].field,
                                    "ignoreCase": "true"
                                });
                            }
                        }

                        if (options.sort && CustomSortingObject) {
                            for (let s = 0; s < options.sort.length; s++) {
                                let CustomSortField = CustomSortingObject[options.sort[s].field];
                                if (CustomSortField) {
                                    options.sort[s].field = CustomSortField;
                                }
                            }
                        }

                        

                        if (!options.sort) {
                            if (sortField) {
                                options.sort = [{ field: sortField, dir: sortType }];
                            }
                        }
                        else if (options.sort.length == 0)
                            options.sort.push({ field: sortField, dir: sortType });

                        if (SortCallBack != null) {
                            SortCallBack(options);
                        }


                        var paramMap = kendo.data.transports.odata.parameterMap(options);
                        delete paramMap.$inlinecount; // <-- remove inlinecount parameter.
                        //To Allow Grid Filtring where it search with "Substring" Keyword and Odata  understand only "contains" Keyword so 
                        //this lines will loop for filters and replace itv with  the correct formate

                        if (paramMap.$filter) {

                            paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
                                return x.substring(1, x.length - 1);
                            });
                            paramMap.$filter = "";

                            let GetFilterStr = (FilterObj) => {

                                let GetNoOffsetDate = (date) => {
                                    let offset = date.getTimezoneOffset() * 60000;
                                    return (new Date(new Date(date) - offset));
                                }
                                
                                if (FilterObj.operator) {
                                    switch (FilterObj.operator) {
                                        case "lte": return `cast(${FilterObj.field},'Edm.DateTimeOffset') le ${GetNoOffsetDate(FilterObj.value).toISOString()}`;
                                        case "gte": return `cast(${FilterObj.field},'Edm.DateTimeOffset') ge ${GetNoOffsetDate(FilterObj.value).toISOString()}`;
                                        case "contains": return `contains(tolower(${FilterObj.field}),tolower('${FilterObj.value}'))`;
                                        case "eq": return `${FilterObj.field} ${FilterObj.operator} ${FilterObj.value}`;
                                        default: return null;
                                    }
                                } else return null
                            }

                            let FiltersStr = "";

                            for (var i = 0; i < options.filter.filters.length; i++) {

                                let FilterStr = "("

                                if (options.filter.filters[i].filters) {
                                    for (let l = 0; l < options.filter.filters[i].filters.length; l++) {
                                        FilterStr = FilterStr + GetFilterStr(options.filter.filters[i].filters[l]);
                                        if (l < options.filter.filters[i].filters.length - 1 &&
                                            options.filter.filters[i].logic) {
                                            FilterStr = FilterStr + " " + options.filter.filters[i].logic + " ";
                                        }
                                    }
                                }
                                else {
                                    FilterStr = FilterStr + GetFilterStr(options.filter.filters[i]);
                                }

                                if (i < options.filter.filters.length - 1 &&
                                    options.filter.logic) {
                                    FilterStr = FilterStr + ") " + options.filter.logic + " ";
                                } else {
                                    FilterStr = FilterStr + ") ";
                                }

                                FiltersStr = FiltersStr + FilterStr;
                            }

                            paramMap.$filter = FiltersStr;
                        }

                        if (parameterMapExtendedOptions) {
                            paramMap = Object.assign({}, paramMap, parameterMapExtendedOptions)
                        }

                        return paramMap;
                    },
                },
                error: function (e) {

                    var xhr = e.xhr;

                    //var statusCode = e.status;
                    //var errorThrown = e.errorThrown;
                    if (xhr.status == 422) {
                        if (xhr.getAllResponseHeaders().toLowerCase().indexOf('sessionexpire') > -1) {//expired token and not authorized                            
                            EventBus.$emit('InternalServerError', xhr.statusText);
                            localStorage.clear();
                            router.push('/');
                        }
                        else {
                            router.push('/401');
                        }
                    }
                    else if (xhr.status == 500) {
                        // $state.go("app.error");
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 0) {
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 205) {
                        console.log(xhr.status);

                    }
                    else if (xhr.responseText != null && xhr.responseText.includes("StatusCode: 401")) {
                        //window.location.href = backOfficeUrl + "401";
                        router.push('/401');
                    }

                    else {
                        console.log(xhr.status);
                    }

                },
                schema: {

                    data: function (data) {

                        if (Array.isArray(data)) {
                            return data
                        }
                        return data.value; // <-- The result is just the data, it doesn't need to be unpacked.
                    },

                    total: function (data) {

                        if (Array.isArray(data)) {
                            return data.length
                        }
                        return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.

                    }
                    ,

                    model: {
                        id: modelID,//this ensures correct editing and deleting when using kewndo grid editing mode
                        fields: fields
                    }

                },

            };


        }
        else if (isWithPaging == false) {
            this.data = {
                type: "odata-v4",
                serverFiltering: true,
                serverPaging: true,
                serverSorting: true,
                transport: {
                    read: {
                        url: url,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        xhrFields: {
                            withCredentials: true
                        },
                        beforeSend: function (xhr) {//Token                        
                            var token = "";
                            xhr.withCredentials = true;
                            if (storage.getItem('Token') != null)
                                token = storage.getItem('Token').Value;
                            xhr.setRequestHeader('Authentication', token);

                        }
                    },
                    parameterMap: function (options) {
                        if (!isListMode) {
                            for (var z = 0; z < DDlFilterParams.length; z++) {
                                options.filter.filters.push({
                                    "value": DDlFilterParams[z].value,
                                    "operator": DDlFilterParams[z].operator,
                                    "field": DDlFilterParams[z].field,
                                    "ignoreCase": "true"
                                });
                            }
                        }

                        if (options.sort && CustomSortingObject) {
                            for (let s = 0; s < options.sort.length; s++) {
                                let CustomSortField = CustomSortingObject[options.sort[s].field];
                                if (CustomSortField) {
                                    options.sort[s].field = CustomSortField;
                                }
                            }
                        }

                        if (!options.sort)
                            options.sort = [{ field: sortField, dir: sortType }];
                        else if (options.sort.length == 0)
                            options.sort.push({ field: sortField, dir: sortType });
                        var paramMap = kendo.data.transports.odata.parameterMap(options);
                        delete paramMap.$inlinecount; // <-- remove inlinecount parameter.
                        //To Allow Grid Filtring where it search with "Substring" Keyword and Odata  understand only "contains" Keyword so 
                        //this lines will loop for filters and replace itv with  the correct formate
                        if (paramMap.$filter) {

                            paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
                                return x.substring(1, x.length - 1);
                            });

                            var Params = paramMap.$filter.split(" and ");
                            paramMap.$filter = "";
                            for (var i = 0; i < Params.length; i++) {
                                var field = options.filter.filters[i].field;
                                var datefilter = Params[i].split("datetime'");
                                if (datefilter.length > 1) {
                                    for (var j = 0; j < datefilter.length; j++) {
                                        if (j == datefilter.length - 1) {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", ".000Z");
                                            //paramMap.$filter = paramMap.$filter + datefilter[j].replace("'", timeZoneOffset);
                                        }
                                        else {
                                            paramMap.$filter = paramMap.$filter + datefilter[j].replace(field, "cast(" + field + ",'Edm.DateTimeOffset')");
                                        }
                                    }
                                }
                                else {
                                    paramMap.$filter = paramMap.$filter + Params[i].replace(/substringof\((.+),(.*?)\)/, "contains(tolower($2),tolower($1))");
                                }
                                if (i != Params.length - 1) {
                                    paramMap.$filter = paramMap.$filter + " and ";
                                }
                            }
                        }
                        return paramMap;

                    },
                },
                error: function (e) {
                    var xhr = e.xhr;
                    //var statusCode = e.status;
                    //var errorThrown = e.errorThrown;
                    if (xhr.status == 422) {
                        if (xhr.getAllResponseHeaders().toLowerCase().indexOf('sessionexpire') > -1) {//expired token and not authorized                            
                            EventBus.$emit('InternalServerError', xhr.statusText);
                            localStorage.clear();
                            router.push('/');
                        }
                        else {
                            router.push('/401');
                        }
                    }
                    else if (xhr.status == 500) {
                        // $state.go("app.error");
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 0) {
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 205) {
                        console.log(xhr.status);

                    }
                    else if (xhr.status == 401) {
                        router.push('/401');
                    }
                    else {
                        console.log(xhr.status);

                        // toaster.error($translate.instant("common.ERROROccurred"));
                    }

                },
                schema: {

                    data: function (data) {

                        return data.value; // <-- The result is just the data, it doesn't need to be unpacked.
                    },

                    total: function (data) {
                        return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.

                    }
                    ,

                    model: {
                        id: modelID,//this ensures correct editing and deleting when using kewndo grid editing mode
                        fields: fields
                    }

                },

            };

        }
    }

    
}